import { notification, message } from 'antd';
import React from 'react';
import find from 'lodash/find';
import pick from 'lodash/pick';
import difference from 'lodash/difference';
import moment from 'moment';
import { ArgsProps } from 'antd/lib/notification';

export const getQueryParam = (url, property) => {
  const params = new URL(url).searchParams;
  return params.get(property);
};

export const isValidUrl = url => {
  const regexp = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/;
  return regexp.test(url);
};

export const isValidEmail = email => {
  const regexp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regexp.test(email);
};

export const resolveAfter = milliseconds =>
  new Promise(resolve => setTimeout(resolve, milliseconds));

export const getDefaultRoute = routesArray =>
  find(routesArray, { default: true, hidden: false }) || routesArray[0];

export const addIdPrefix = (errorDescription = '') =>
  `##${Math.floor(Math.random() * 1000)}##${errorDescription}`;

const removeIdPrefix = (errorDescription = '') =>
  errorDescription.replace(/##\d+##/, '');

export const showInfoNotification = description => {
  notification.info({
    message: 'Info',
    description: description,
  });
};

export const showErrorNotification = (description, opts: ArgsProps = {}) => {
  notification.error({
    message: 'Error',
    description: (
      <div style={{ whiteSpace: 'pre-wrap' }}>
        {removeIdPrefix(description) || ''}
      </div>
    ),
    ...opts,
  });
};

export const showSuccessNotification = (
  description,
  { duration = 5, key } = {},
) => {
  notification.success({
    message: 'Success',
    description: description || '',
    duration,
    key,
  });
};

export const showWarningNotification = description => {
  notification.warning({
    message: 'Warning',
    description: description || '',
  });
};

export const shortUuid = () =>
  Math.random()
    .toString(36)
    .substr(2, 9);

export const mergeMenuItems = (parentRoutes, currentRoutes) => {
  const { path: defaultPath } = getDefaultRoute(currentRoutes);
  return parentRoutes.map(route =>
    defaultPath.indexOf(route.path) === 0
      ? { ...route, group: currentRoutes }
      : route,
  );
};

export const showMessage = (textMessage, type = 'success') => {
  if (textMessage) message[type](textMessage);
};

export const addComponentsToRoutes = (routes, components) =>
  routes.map(route => {
    const component = components[route.path];
    if (!component) {
      const error = new Error(`Missing component for: ${route.path}`);
      throw error;
    }
    return { ...route, component };
  });

export const removeKeysFromObject = (object, unwantedKeys) => {
  const objectKeys = Object.keys(object);
  const remainingKeys = difference(objectKeys, unwantedKeys);
  return pick(object, remainingKeys);
};

export const checkId = (id, errorMessage) => {
  if (!id && id !== 0) throw new Error(errorMessage);
};

export const createDomEvent = (eventName, data = {}) => {
  const event = new CustomEvent(eventName, { detail: data });
  window.dispatchEvent(event);
};

export const dateFormatPipe = (date, format) => {
  if (!date) date = new Date();
  if (!format) format = 'DD/MM/YYYY';
  return moment(date).format(format);
};
